import { useState, useEffect, useCallback } from 'react';
import { Divider, Dialog, Button } from '@mui/material';
import classes from './SubscriptionSection.module.scss';
import i18n from '../../../../utils/i18n';
import SubscriptionRow from './components/SubscriptionRow';
import MarketingBanner from '../../../components/MarketingBanner';
import PackageLady from '../../../images/banner-insurance-lady.svg';
import CustomButton from '../../../components/CustomButton';
import IconPlus from '../../../images/icon-plus.svg';
import SelectorDual from '../../../components/SelectorDual';
import SubscriptionPackage from './components/SubscriptionPackage';
import SubscriptionFinalize from './components/SubscriptionFinalize';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from '../../../../redux/action';
import { CalComSub } from './components/CalComSub';
import SubscriptionSuccess from './components/SubscriptionSuccess';
import axios from '../../../../shared/axios/axiosProxy';
import PackageInfoBasic from './components/PackageInfoBasic';
import PackageInfoMarketing from './components/PackageInfoMarketing';
import PackageInfoAssurance from './components/PackageInfoAssurance';

// import { subscriptionPackages } from '../../../data/providerText';

const subscriptionPackages = {
	entrepreneur: {
		package_name: i18n.t('providersubscription.entrepreneurpack'), //noofemployees = 1
		package_dbName: 'entrepreneur',
		noofemployees: [1, 1],
		basic_yearlyPricePerMonth: 0,
		basic_yearlyPrice: 0,
		basic_monthly: 0,
		basic_discountIfYearly: 0,
		advanced_yearlyPricePerMonth: 6900,
		advanced_yearlyPrice: 82800,
		advanced_monthly: 55200,
		advanced_discountIfYearly: 27600,
		premium_yearlyPricePerMonth: 11375,
		premium_yearlyPrice: 136500,
		premium_monthly: 91000,
		premium_discountIfYearly: 45500,
		mkoestart_yearlyPricePerMonth: 0,
		mkoestart_yearlyPrice: 0,
		mkoestart_monthly: 0,
		mkoestart_discountIfYearly: 0,
	},
	small_office: {
		package_name: i18n.t('providersubscription.smallofficepack'), //noofemployees = 2-5
		package_dbName: 'small_office',
		noofemployees: [2, 5],
		basic_yearlyPricePerMonth: 0,
		basic_yearlyPrice: 0,
		basic_monthly: 0,
		basic_discountIfYearly: 0,
		advanced_yearlyPricePerMonth: 9900,
		advanced_yearlyPrice: 118800,
		advanced_monthly: 79200,
		advanced_discountIfYearly: 39600,
		premium_yearlyPricePerMonth: 17125,
		premium_yearlyPrice: 205500,
		premium_monthly: 135000,
		premium_discountIfYearly: 64500,
		mkoestart_yearlyPricePerMonth: 0,
		mkoestart_yearlyPrice: 0,
		mkoestart_monthly: 0,
		mkoestart_discountIfYearly: 0,
	},
	office: {
		package_name: i18n.t('providersubscription.officepack'), //noofemployees = 6-20
		package_dbName: 'office',
		noofemployees: [6, 20],
		basic_yearlyPricePerMonth: 0,
		basic_yearlyPrice: 0,
		basic_monthly: 0,
		basic_discountIfYearly: 0,
		advanced_yearlyPricePerMonth: 14900,
		advanced_yearlyPrice: 178800,
		advanced_monthly: 118800,
		advanced_discountIfYearly: 58800,
		premium_yearlyPricePerMonth: 22875,
		premium_yearlyPrice: 274500,
		premium_monthly: 168000,
		premium_discountIfYearly: 61500,
		mkoestart_yearlyPricePerMonth: 0,
		mkoestart_yearlyPrice: 0,
		mkoestart_monthly: 0,
		mkoestart_discountIfYearly: 0,
	},
	corporate: {
		package_name: i18n.t('providersubscription.corporatepack'), //noofemployees = above 20
		package_dbName: 'corporate',
		noofemployees: 21, //and above
		basic_yearlyPricePerMonth: 0,
		basic_yearlyPrice: 0,
		basic_monthly: 0,
		basic_discountIfYearly: 0,
		advanced_yearlyPricePerMonth: 19900,
		advanced_yearlyPrice: 238800,
		advanced_monthly: 159000,
		advanced_discountIfYearly: 79200,
		premium_yearlyPricePerMonth: 34500,
		premium_yearlyPrice: 414000,
		premium_monthly: 275000,
		premium_discountIfYearly: 136000,
		mkoestart_yearlyPricePerMonth: 0,
		mkoestart_yearlyPrice: 0,
		mkoestart_monthly: 0,
		mkoestart_discountIfYearly: 0,
	},
};

const SubscriptionSection = ({ submitToDB }) => {
	const dispatch = useDispatch();
	const providerID = useSelector((state) => state.providerID);
	const providerInfo = useSelector((state) => state.provider_info);
	const providerPackage = useSelector((state) => state.provider_package);
	const providerSubscription = useSelector(
		(state) => state.provider_subscription
	);
	useEffect(() => {
		if (
			providerPackage.packageType === '' &&
			providerInfo.email !== '' &&
			providerInfo.companyname !== '' &&
			providerInfo.phone !== ''
		) {
			dispatch(
				ACTIONS.addProviderInfo({
					id: 'packageType',
					data: 'basic',
					stateObject: 'provider_package',
				})
			);
			dispatch(
				ACTIONS.addProviderInfo({
					id: 'finishedRegistration',
					data: true,
					stateObject: 'userData',
				})
			);
			dispatch(
				ACTIONS.addProviderInfo({
					id: 'startDate',
					data: Date.now(),
					stateObject: 'provider_package',
				})
			);
			const data = {
				provider_subscription: providerSubscription,
				finishedRegistration: true,
				provider_package: providerPackage,
			};

			submitToDB(data);
		}
	}, [providerInfo, providerPackage]);

	// console.log(
	// 	providerPackage?.packagePrice,
	// 	'packagePrice'
	// 	// providerSubscription,
	// 	// 'providerSubscription'
	// );
	const [open, setOpen] = useState(false);
	const [openSubPackageBasic, setOpenSubPackageBasic] = useState(false);
	const [openSubPackageMarketing, setOpenSubPackageMarketing] = useState(false);
	const [openSubPackageAssurance, setOpenSubPackageAssurance] = useState(false);
	const [openSubFinalize, setOpenSubFinalize] = useState(false);
	const [openSubSuccess, setOpenSubSuccess] = useState(false);
	const [openMarketingInfo, setOpenMarketingInfo] = useState(false);
	const [openAssuranceInfo, setOpenAssuranceInfo] = useState(false);
	const [openBasicInfo, setOpenBasicInfo] = useState(false);

	const numberWithCommas = (x) => {
		if (x || x === 0) {
			return Math.round(x)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
		}
	};

	useEffect(() => {
		console.log('PROVIDER PACKAGE', providerPackage.packageType);
	}, [providerPackage]);

	const handlePaymentFrequency = (selectedOption) => {
		// console.log('YEARLY BEFORE DISPATCH', providerPackage.yearly)
		// console.log('SELECTED OPTION', selectedOption)

		dispatch(
			ACTIONS.addProviderInfo({
				id: 'yearly',
				data: selectedOption === 'yearly',
				stateObject: 'provider_package',
			})
		);
	};

	const handleSubscribeBasic = () => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'packageType',
				data: 'basic',
				stateObject: 'provider_package',
			})
		);
		setOpenSubPackageBasic(true);
	};

	const selectSubscribeBasic = () => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'packageType',
				data: 'basic',
				stateObject: 'provider_package',
			})
		);
	};

	const handleSubscribeMarketing = () => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'packageType',
				data: 'advanced',
				stateObject: 'provider_package',
			})
		);
		setOpenSubPackageMarketing(true);
	};

	const selectSubscribeMarketing = () => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'packageType',
				data: 'advanced',
				stateObject: 'provider_package',
			})
		);
	};

	const handleSubscribeAssurance = () => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'packageType',
				data: 'premium',
				stateObject: 'provider_package',
			})
		);
		setOpenSubPackageAssurance(true);
	};

	const selectBasicInfo = () => {
		setOpenBasicInfo(true);
	};

	const selectMarketingInfo = () => {
		setOpenMarketingInfo(true);
	};

	const selectAssuranceInfo = () => {
		setOpenAssuranceInfo(true);
	};

	const setPrice = () => {
		let price = 0;
		if (providerPackage.yearly) {
			price =
				subscriptionPackages[providerPackage.packageSize][
					`${providerPackage.packageType}_yearlyPrice`
				];
		} else {
			price =
				subscriptionPackages[providerPackage.packageSize][
					`${providerPackage.packageType}_monthly`
				];
		}

		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'packagePrice',
				data: price,
				stateObject: 'provider_package',
			})
		);
	};

	useEffect(() => {
		setPrice();
	}, [providerPackage.packageType]);

	const selectSubscribeAssurance = () => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'packageType',
				data: 'premium',
				stateObject: 'provider_package',
			})
		);
	};

	useEffect(() => {
		console.log('PROVIDER INFO', providerInfo);
	}, [providerInfo]);

	const handleMarketingBannerClick = () => {
		CalComSub(providerInfo, providerPackage);
	};

	const getSubTitle = () => {
		switch (providerPackage.packageType) {
			case 'basic':
				return i18n.t('provider.subsuccesssubtitbasic');
			case 'advanced':
				return i18n.t('provider.subsuccesssubtitleadv');
			case 'premium':
				return i18n.t('provider.subsuccesssubtitlepre');
			default:
				return i18n.t('provider.subsuccesssubtitledefault');
		}
	};

	const getFirstRow = () => {
		switch (providerPackage.packageType) {
			case 'basic':
				return `${i18n.t('provider.subscriptionrow1')} ${i18n.t(
					'provider.subscriptionrow1'
				)}`;
			case 'advanced':
				return `${i18n.t('provider.subscriptionrow1')} ${i18n.t(
					'provider.subscriptionrow1'
				)}`;
			case 'premium':
				return `${i18n.t('provider.subscriptionrow1')} ${i18n.t(
					'provider.subscriptionrow1'
				)}`;
			default:
				return '';
		}
	};

	const getSecondRow = () => {
		switch (providerPackage.packageType) {
			case 'basic':
				return '';
			case 'advanced':
				return `${i18n.t('provider.subscriptionrow3')} ${i18n.t(
					'provider.subscriptionrow3'
				)}`;
			case 'premium':
				return `${i18n.t('provider.subscriptionrow3')} ${i18n.t(
					'provider.subscriptionrow3'
				)}`;
			default:
				return '';
		}
	};

	const getThirdRow = () => {
		switch (providerPackage.packageType) {
			case 'basic':
				return '';
			case 'advanced':
				return i18n.t('provider.subscriptionrow5');
			case 'premium':
				return i18n.t('provider.subscriptionrow4');
			default:
				return '';
		}
	};

	const suspendSubscription = async () => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'activeSubscription',
				data: false,
				stateObject: 'provider_subscription',
			})
		);
		await submitDB(
			{
				'provider_subscription.activeSubscription': false,
				'provider_subscription.statusChanged': new Date(),
			},
			'suspendSub'
		);
		await updateSubscription({ 'subscription.activeSubscription': false });
		setOpen(false);
	};

	const continueSubscription = async () => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'activeSubscription',
				data: true,
				stateObject: 'provider_subscription',
			})
		);
		await submitDB(
			{
				'provider_subscription.activeSubscription': true,
				'provider_subscription.statusChanged': new Date(),
			},
			'continueSub'
		);
		await updateSubscription({ 'subscription.activeSubscription': true });
	};

	const submitDB = async (field, type, newPackageType) => {
		let data = field;
		const JWT = localStorage.getItem('JWT');
		axios
			.patch('/api/provider', JSON.stringify(data), {
				headers: {
					Authorization: `Bearer ${JWT}`,
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
				sendEmailNotification(type, newPackageType);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			})
			.catch((error) => console.log('submitToDB error', error));
	};

	const sendEmailNotification = (type, newPackageType) => {
		const data = {
			user: providerInfo.companyname,
			type: type,
			newPackageType: newPackageType || '',
		};
		axios
			.post('/api/contact/notification', data)
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			})
			.catch((error) => console.log('submitToDB error', error));
	};

	const updateSubscription = async (data) => {
		axios
			.patch(`/api/subscription/${providerID}`, JSON.stringify(data), {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			})
			.catch((error) => console.log('submitToDB error', error));
	};

	return (
		<div className={classes.dashboard}>
			<Dialog open={open} onClose={() => setOpen(false)}>
				<div className={classes.CancelSubscriptionContainer}>
					<h2>{i18n.t('providerdashboard.subtext1')}</h2>
					<p>{i18n.t('providerdashboard.subtext2')}</p>
					<CustomButton
						onClick={() => {
							setOpen(true);
							suspendSubscription();
						}}
						buttonName={i18n.t('providerdashboard.yescancelsub')}
						buttonColor="#1c32f3"
						hoverColor="#0036cc"
						titleColor="#ffffff"
						titleHoverColor="#e0e0e0"
						width="100%"
						height="44px"
						padding="12px"
					/>
					<p></p>
					<CustomButton
						onClick={() => {
							setOpen(false);
						}}
						buttonName={i18n.t('providerdashboard.undo')}
						titleColor="#1c32f3"
						hoverColor="#0036cc"
						buttonColor="#ffffff"
						titleHoverColor="#e0e0e0"
						width="100%"
						height="44px"
						padding="12px"
						borderColor="#1c32f3"
						borderWidth="1px"
					/>
				</div>
			</Dialog>

			<div className={classes.mainTitle}>{i18n.t('provider.subscription')}</div>

			<Divider />

			<div className={classes.paragraph}>
				<div className={classes.column}>
					<div className={classes.columnHeader}>
						{i18n.t('provider.paymentfrequency')}
					</div>
					<div className={classes.columnContent}>
						<SelectorDual
							id="paymentFrequency"
							options={[
								{ label: i18n.t('general.biannual'), value: 'biannual' },
								{ label: i18n.t('provider.yearlyminus20'), value: 'yearly' },
							]}
							onSelect={(option) => {
								handlePaymentFrequency(option.value);
							}}
							initialValue={providerPackage.yearly ? 'yearly' : 'biannual'}
						/>
					</div>
				</div>

				<div className={classes.column}>
					<div className={classes.columnHeader}>
						{i18n.t('provider.entrypackage')}
					</div>
					<div className={classes.columnContent}>
						<div className={classes.priceWrapper}>
							<div className={classes.price}>{i18n.t('provider.free')}</div>
						</div>
						<div className={classes.priceSubTitle}>
							{i18n.t('provider.freesubtitle')}
						</div>
						{providerPackage.packageType === 'basic' ? (
							<CustomButton
								buttonName={i18n.t('provider.currentpackage')}
								titleColor="#1c32f3"
								hoverColor="#0036cc"
								buttonColor="#ffffff"
								titleHoverColor="#e0e0e0"
								width="100%"
								height="44px"
								padding="12px"
								borderColor="#1c32f3"
								borderWidth="1px"
							/>
						) : (
							<CustomButton
								buttonName={i18n.t('provider.subscribe')}
								iconSrc={IconPlus}
								buttonColor="#1c32f3"
								hoverColor="#0036cc"
								titleColor="#ffffff"
								titleHoverColor="#e0e0e0"
								width="100%"
								height="44px"
								padding="12px"
								onClick={handleSubscribeBasic}
								// isDisabled={providerSubscription.activeSubscription}
							/>
						)}
						<div className={classes.moreInfo} onClick={selectBasicInfo}>
							{i18n.t('provider.needmoreinfo')}
						</div>
					</div>
				</div>

				<div className={classes.column}>
					<div className={classes.columnHeader}>
						{i18n.t('provider.marketingpackage')}
					</div>
					<div className={classes.columnContent}>
						<div className={classes.priceWrapper}>
							<div className={classes.price}>
								{`${
									providerPackage.yearly
										? numberWithCommas(
												subscriptionPackages[providerPackage.packageSize]
													.advanced_yearlyPricePerMonth
										  )
										: numberWithCommas(
												subscriptionPackages[providerPackage.packageSize]
													.advanced_monthly / 6
										  )
								} ${i18n.t('provider.currency/month')}`}
							</div>
							<div className={classes.discount}>
								{`${
									providerPackage.yearly
										? numberWithCommas(
												subscriptionPackages[providerPackage.packageSize]
													.advanced_yearlyPrice
										  )
										: numberWithCommas(
												subscriptionPackages[providerPackage.packageSize]
													.advanced_monthly * 2
										  )
								} ${i18n.t('provider.currency/year')}`}
							</div>
						</div>
						<div className={classes.priceSubTitle}>
							{i18n.t('provider.marketingsubtitle')}
						</div>
						{providerPackage.packageType === 'advanced' ? (
							<CustomButton
								buttonName={i18n.t('provider.currentpackage')}
								titleColor="#1c32f3"
								hoverColor="#0036cc"
								buttonColor="#ffffff"
								titleHoverColor="#e0e0e0"
								width="100%"
								height="44px"
								padding="12px"
								borderColor="#1c32f3"
								borderWidth="1px"
							/>
						) : (
							<CustomButton
								buttonName={i18n.t('provider.subscribe')}
								iconSrc={IconPlus}
								buttonColor="#1c32f3"
								hoverColor="#0036cc"
								titleColor="#ffffff"
								titleHoverColor="#e0e0e0"
								width="100%"
								height="44px"
								padding="12px"
								onClick={handleSubscribeMarketing}
								// isDisabled={providerSubscription.activeSubscription}
							/>
						)}
						{/* <CustomButton
              buttonName={i18n.t('provider.cancelsubscription')}
              buttonColor="#fafcfe"
              hoverColor="#fafcfe"
              titleColor="#4b5080"
              titleHoverColor="#4b5080"
              width="100%"
              height="44px"
              padding="12px"
              borderColor="#e3e5e9"
              borderWidth="1px"
              // onClick={handleCancelMarketing}
            /> */}
						<div className={classes.moreInfo} onClick={selectMarketingInfo}>
							{i18n.t('provider.needmoreinfo')}
						</div>
					</div>
				</div>

				<div className={classes.column}>
					<div className={classes.columnHeader}>
						{i18n.t('provider.assurancepackage')}
					</div>
					<div className={classes.columnContent}>
						<div className={classes.priceWrapper}>
							<div className={classes.price}>
								{`${
									providerPackage.yearly
										? numberWithCommas(
												subscriptionPackages[providerPackage.packageSize]
													.premium_yearlyPricePerMonth
										  )
										: numberWithCommas(
												subscriptionPackages[providerPackage.packageSize]
													.premium_monthly / 6
										  )
								} ${i18n.t('provider.currency/month')}`}
							</div>
							<div className={classes.discount}>
								{`${
									providerPackage.yearly
										? numberWithCommas(
												subscriptionPackages[providerPackage.packageSize]
													.premium_yearlyPrice
										  )
										: numberWithCommas(
												subscriptionPackages[providerPackage.packageSize]
													.premium_monthly * 2
										  )
								} ${i18n.t('provider.currency/year')}`}
							</div>
						</div>
						<div className={classes.priceSubTitleBold}>
							{i18n.t('provider.assurancesubtitlebold')}{' '}
							<span className={classes.priceSubTitle}>
								{i18n.t('provider.assurancesubtitle')}
							</span>
						</div>
						{providerPackage.packageType === 'premium' ? (
							<CustomButton
								buttonName={i18n.t('provider.currentpackage')}
								titleColor="#1c32f3"
								hoverColor="#0036cc"
								buttonColor="#ffffff"
								titleHoverColor="#e0e0e0"
								width="100%"
								height="44px"
								padding="12px"
								borderColor="#1c32f3"
								borderWidth="1px"
							/>
						) : (
							<CustomButton
								buttonName={i18n.t('provider.subscribe')}
								iconSrc={IconPlus}
								buttonColor="#1c32f3"
								hoverColor="#0036cc"
								titleColor="#ffffff"
								titleHoverColor="#e0e0e0"
								width="100%"
								height="44px"
								padding="12px"
								onClick={handleSubscribeAssurance}
								// isDisabled={providerSubscription.activeSubscription}
							/>
						)}
						{/* <CustomButton
              buttonName={i18n.t('hardcoded.cancelSubscription')}
              buttonColor="#fafcfe"
              hoverColor="#fafcfe"
              titleColor="#4b5080"
              titleHoverColor="#4b5080"
              width="100%"
              height="44px"
              padding="12px"
              borderColor="#e3e5e9"
              borderWidth="1px"
            // onClick={handleCancelAssurance}
            /> */}
						<div className={classes.moreInfo} onClick={selectAssuranceInfo}>
							{i18n.t('provider.needmoreinfo')}
						</div>
					</div>
				</div>

				<SubscriptionPackage
					openSubPackage={openSubPackageBasic}
					setOpenSubPackage={setOpenSubPackageBasic}
					title={i18n.t('provider.entrypackage')}
					subTitle={i18n.t('provider.basicsub')}
					firstRow={`${i18n.t('provider.subscriptionrow1')} ${i18n.t(
						'provider.subscriptionrow1'
					)}`}
					onConfirm={async () => {
						selectSubscribeBasic();
						const data = {
							provider_subscription: providerSubscription,
							finishedRegistration: true,
							provider_package: providerPackage,
						};
						await submitToDB(data);
						sendEmailNotification('changePackageType', 'Basic');
						setOpenSubSuccess(true);
					}}
				/>

				<SubscriptionPackage
					openSubPackage={openSubPackageMarketing}
					setOpenSubPackage={setOpenSubPackageMarketing}
					title={i18n.t('provider.marketingpackage')}
					subTitle={i18n.t('provider.marketingsub')}
					firstRow={`${i18n.t('provider.subscriptionrow1')} ${i18n.t(
						'provider.subscriptionrow1'
					)}`}
					secondRow={`${i18n.t('provider.subscriptionrow3')} ${i18n.t(
						'provider.subscriptionrow3'
					)}`}
					thirdRow={i18n.t('provider.subscriptionrow5')}
					onConfirm={() => {
						setOpenSubFinalize(true);
						selectSubscribeMarketing();
					}}
				/>

				<SubscriptionPackage
					openSubPackage={openSubPackageAssurance}
					setOpenSubPackage={setOpenSubPackageAssurance}
					title={i18n.t('provider.assurancepackage')}
					subTitle={i18n.t('provider.assurancesub')}
					firstRow={`${i18n.t('provider.subscriptionrow1')} ${i18n.t(
						'provider.subscriptionrow1'
					)}`}
					secondRow={`${i18n.t('provider.subscriptionrow3')} ${i18n.t(
						'provider.subscriptionrow3'
					)}`}
					thirdRow={i18n.t('provider.subscriptionrow4')}
					onConfirm={() => {
						setOpenSubFinalize(true);
						selectSubscribeAssurance();
					}}
				/>

				<SubscriptionFinalize
					openSubFinalize={openSubFinalize}
					setOpenSubFinalize={setOpenSubFinalize}
					setOpenSubSuccess={setOpenSubSuccess}
					submitToDB={submitToDB}
					sendEmailNotification={sendEmailNotification}
				/>

				<PackageInfoBasic
					openBasicInfo={openBasicInfo}
					setOpenBasicInfo={setOpenBasicInfo}
					title={i18n.t('provider.entrypackage')}
					subTitle={i18n.t('provider.basicsub')}
					onConfirm={() => {
						setOpenBasicInfo(true);
					}}
				/>

				<PackageInfoMarketing
					openMarketingInfo={openMarketingInfo}
					setOpenMarketingInfo={setOpenMarketingInfo}
					title={i18n.t('provider.marketingpackage')}
					subTitle={i18n.t('provider.marketingsub')}
					onConfirm={() => {
						setOpenMarketingInfo(true);
					}}
				/>

				<PackageInfoAssurance
					openAssuranceInfo={openAssuranceInfo}
					setOpenAssuranceInfo={setOpenAssuranceInfo}
					title={i18n.t('provider.assurancepackage')}
					subTitle={i18n.t('provider.assurancesub')}
					onConfirm={() => {
						setOpenAssuranceInfo(true);
					}}
				/>

				{/* <SubscriptionSuccess
          openSubSuccess={openSubSuccess}
          setOpenSubSuccess={setOpenSubSuccess}
          title={i18n.t('provider.subsuccesstitle')}
          subTitle={
            providerPackage.packageType === 'advanced'
              ? i18n.t('provider.subsuccesssubtitleadv')
              : i18n.t('provider.subsuccesssubtitlepre')
          }
          firstRow={
            providerPackage.packageType === 'advanced'
              ? i18n.t('provider.subscriptionrow6')
              : i18n.t('provider.subscriptionrow9')
          }
          secondRow={
            providerPackage.packageType === 'advanced'
              ? i18n.t('provider.subscriptionrow7')
              : i18n.t('provider.subscriptionrow10')
          }
          thirdRow={
            providerPackage.packageType === 'advanced'
              ? i18n.t('provider.subscriptionrow8')
              : i18n.t('provider.subscriptionrow11')
          }
        /> */}

				<SubscriptionSuccess
					openSubSuccess={openSubSuccess}
					setOpenSubSuccess={setOpenSubSuccess}
					title={i18n.t('provider.subsuccesstitle')}
					subTitle={getSubTitle()}
					firstRow={getFirstRow()}
					secondRow={getSecondRow()}
					thirdRow={getThirdRow()}
				/>
			</div>

			<div className={classes.subscriptionrows}>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={
						<>
							{i18n.t('provider.subscriptionrow1')}{' '}
							<strong>{i18n.t('provider.subscriptionrow1')}</strong>
						</>
					}
					tick1={true}
					tick2={true}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				{/* <SubscriptionRow
					title={
						<>
							<strong>{i18n.t('provider.subscriptionrow2')}{' '}</strong>
							{i18n.t('provider.subscriptionrow2')}
						</>
					}
					tick1={true}
					tick2={false}
					tick3={false}
				/> */}
				{/* <Divider sx={{ margin: '0 18px' }} /> */}
				<SubscriptionRow
					title={
						<>
							<strong>{i18n.t('provider.subscriptionrow3')} </strong>
							{i18n.t('provider.subscriptionrow3')}
						</>
					}
					tick1={false}
					tick2={true}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={i18n.t('provider.subscriptionrow5')}
					tick1={false}
					tick2={true}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={
						<>
							<strong>{i18n.t('provider.subscriptionrow6')} </strong>
							{i18n.t('provider.subscriptionrow6')}
						</>
					}
					tick1={false}
					tick2={true}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={i18n.t('provider.subscriptionrow4')}
					tick1={false}
					tick2={false}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={<strong>{i18n.t('provider.subscriptionrow7')} </strong>}
					tick1={false}
					tick2={false}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={
						<>
							<strong>{i18n.t('provider.subscriptionrow8')} </strong>
							{i18n.t('provider.subscriptionrow8')}
						</>
					}
					tick1={false}
					tick2={false}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={i18n.t('provider.subscriptionrow9')}
					tick1={false}
					tick2={false}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={i18n.t('provider.subscriptionrow10')}
					tick1={false}
					tick2={false}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
				<SubscriptionRow
					title={
						<>
							{i18n.t('provider.subscriptionrow11')}{' '}
							<strong>{i18n.t('provider.subscriptionrow11')}</strong>
						</>
					}
					tick1={false}
					tick2={false}
					tick3={true}
				/>
				<Divider sx={{ margin: '0 18px' }} />
			</div>

			<div className={classes.marketingBanner}>
				<MarketingBanner
					imgSrc={PackageLady}
					title={i18n.t('provider.marketingbannertitle')}
					subtitle={i18n.t('provider.marketingbannersubtitle')}
					subtitlecontact={i18n.t('provider.marketingbannersubtitlecontact')}
					imgWidth="75px"
					imgMarginLeft="16px"
					buttonLabel={i18n.t('general.booking')}
					onButtonClick={() => handleMarketingBannerClick()}
				/>
			</div>
			<div className={classes.cancelSubButtonContainer}>
				{providerSubscription.activeSubscription ? (
					<CustomButton
						onClick={() => {
							setOpen(true);
						}}
						buttonName={i18n.t('providerdashboard.cancelsub')}
						titleColor="#1c32f3"
						hoverColor="#0036cc"
						buttonColor="#ffffff"
						titleHoverColor="#e0e0e0"
						width="100%"
						height="44px"
						padding="12px"
						borderColor="#1c32f3"
						borderWidth="1px"
					/>
				) : (
					<CustomButton
						onClick={() => {
							continueSubscription();
						}}
						buttonName={i18n.t('providerdashboard.continuesub')}
						buttonColor="#1c32f3"
						hoverColor="#0036cc"
						titleColor="#ffffff"
						titleHoverColor="#e0e0e0"
						width="100%"
						height="44px"
						padding="12px"
					/>
				)}
			</div>
		</div>
	);
};

export default SubscriptionSection;
